/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const ClaimsSchemaFieldStructValue: core.serialization.ObjectSchema<
    serializers.ClaimsSchemaFieldStructValue.Raw,
    Truvity.ClaimsSchemaFieldStructValue
> = core.serialization.object({
    fields: core.serialization.list(core.serialization.lazy(() => serializers.ClaimsSchemaFieldStructValueFieldsItem)),
    isArray: core.serialization.property('is_array', core.serialization.boolean().optional()),
    jsonLdBaseIri: core.serialization.property('json_ld_base_iri', core.serialization.string().optional()),
    jsonLdIri: core.serialization.property('json_ld_iri', core.serialization.string().optional()),
    jsonLdRelativeIriDelimiter: core.serialization.property(
        'json_ld_relative_iri_delimiter',
        core.serialization.string().optional(),
    ),
    jsonLdTermName: core.serialization.property('json_ld_term_name', core.serialization.string().optional()),
    name: core.serialization.string(),
    notEmpty: core.serialization.property('not_empty', core.serialization.boolean().optional()),
    title: core.serialization.string().optional(),
});

export declare namespace ClaimsSchemaFieldStructValue {
    export interface Raw {
        fields: serializers.ClaimsSchemaFieldStructValueFieldsItem.Raw[];
        is_array?: boolean | null;
        json_ld_base_iri?: string | null;
        json_ld_iri?: string | null;
        json_ld_relative_iri_delimiter?: string | null;
        json_ld_term_name?: string | null;
        name: string;
        not_empty?: boolean | null;
        title?: string | null;
    }
}
